import Marquee from "react-fast-marquee";
import { RIBBON } from "@/lib/data";

const DiamondStar = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M12 0c.9 8.1 3.9 11.1 12 12-8.1.9-11.1 3.9-12 12-.9-8.1-3.9-11.1-12-12C8.1 11.1 11.1 8.1 12 0z" />
  </svg>
);

export const Ribbon = () => (
  <section className="border-y border-[#EAE6E1] bg-sand py-6" data-testid="ribbon-section">
    <Marquee speed={34} gradient={false} autoFill>
      {RIBBON.map((word, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif italic text-3xl md:text-4xl text-[var(--astera-char)]/85 px-8">
            {word}
          </span>
          <DiamondStar className="w-4 h-4 text-clay" />
        </span>
      ))}
    </Marquee>
  </section>
);
